import { render, staticRenderFns } from "./VocabCardData.vue.js?vue&type=template&id=525dd952&scoped=true!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VocabCardData.vue?vue&type=template&id=525dd952&scoped=true"
import script from "./VocabCardData.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VocabCardData.vue?vue&type=script&lang=js"
export * from "./VocabCardData.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VocabCardData.vue?vue&type=script&lang=js"
import style0 from "./VocabCardData.vue.scss?vue&type=style&index=0&id=525dd952&prod&lang=scss&scoped=true!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VocabCardData.vue?vue&type=style&index=0&id=525dd952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525dd952",
  null
  
)

export default component.exports